import { BaseApi } from './base.api.js';
import { ApiError } from '../errors/api-error.js';

export class ReportArchiveApi extends BaseApi {
    constructor(client) {
        super(client, '/report-archives');
    }

    async createWithGrant(data, grantToken) {
        try {
            return (await this.client.post(this.basePath, data, {
                headers: { 'X-Report-Archive-Grant': grantToken },
            })).data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async getViewerAccess(id) {
        try {
            return (await this.client.get(`${this.basePath}/${id}/viewer-access`)).data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }
}
